export default __webpack_public_path__ + "static/media/cloak_of_the_battle_hardened.1f054a20.jpg";